module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAkCAYAAAD7PHgWAAAABGdBTUEAALGPC/xhBQAAAQtJREFUWAlj5BZV28rA8N+LYVACxm2M3KKq/wel26COYhrMjgO5bdSBlMbQaAiOhiClIUCp/tE0OBqClIYApfppkgZZmBkpdRdcP00c2JatxTClTI+BlYVy4yk3Ae5XBKN88lWGbz/+MvQX6VDsSJo48D+wAUctR5LcHswIUmDICFZEBBcB1t0nXxn2nXnNMHX1fQIqsUuT7EDsxmCKMgLzSWeuNgMXBzNDYd8Vht9//mEqIkKEJlFMLceB3E8TB1Ij5GCBS7MohllAKU2TEKTUUcj6Rx2IHBrksEdDkJxQQ9YzGoLIoUEOezQEyQk1ZD2jIYgcGuSwR0OQnFBD1gMMQcZtyAKDi824FQDxXzUiK6SA9QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/button_r2.png
// module id = 4Z0c
// module chunks = 1